"use client";

import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";
import { Button, Link } from "@/components/ui";
import { ClassRegisterCta } from "./ClassRegisterCta";
import { useClassRegistrationCta } from "@/views/classes/hooks/useClassRegistrationCta";

export interface PublicClassRowActionsProps {
  classId: number;
  href: string;
  allowOnlineRegistration?: boolean | null;
}

export const PublicClassRowActions = ({
  classId,
  href,
  allowOnlineRegistration,
}: PublicClassRowActionsProps) => {
  const { showCta } = useClassRegistrationCta(classId, allowOnlineRegistration);

  const viewMoreButton = (opts: { fullWidth: boolean; label: string }) => (
    <Button
      as={Link}
      href={href}
      variant="outline"
      size="sm"
      fontSize="sm"
      px={4}
      w={opts.fullWidth ? "100%" : undefined}
      maxW={opts.fullWidth ? "100%" : undefined}
    >
      {opts.label}
    </Button>
  );

  if (!showCta) {
    return (
      <>
        <Box display={{ base: "block", md: "none" }} w="100%">
          {viewMoreButton({ fullWidth: true, label: "View more" })}
        </Box>
        <Box display={{ base: "none", md: "block" }} flexShrink={0}>
          {viewMoreButton({ fullWidth: false, label: "View class" })}
        </Box>
      </>
    );
  }

  return (
    <>
      <Grid
        display={{ base: "grid", md: "none" }}
        templateColumns="repeat(2, minmax(0, 1fr))"
        gap={2}
        w="100%"
        alignItems="stretch"
      >
        <GridItem minW={0} w="100%">
          <ClassRegisterCta
            classId={classId}
            allowOnlineRegistration={allowOnlineRegistration}
            variant="compact"
            fullWidth
          />
        </GridItem>
        <GridItem minW={0} w="100%">
          {viewMoreButton({ fullWidth: true, label: "View more" })}
        </GridItem>
      </Grid>

      <Flex
        display={{ base: "none", md: "flex" }}
        gap={2}
        flexShrink={0}
        flexWrap="wrap"
        align="center"
      >
        <ClassRegisterCta
          classId={classId}
          allowOnlineRegistration={allowOnlineRegistration}
          variant="compact"
        />
        {viewMoreButton({ fullWidth: false, label: "View class" })}
      </Flex>
    </>
  );
};
